// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__GFbSo","info":"Note_info__1N3Js","note":"Note_note__2ZteJ","actions":"Note_actions__1CLTy"};